






































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BaseCalendarVue, { CalendarEvent } from './baseCalendar.vue';
import { Schedule } from '@/modules/studentCalendar';

export interface SelectableDate {
  date: Date;
  isSelectable: boolean;
  isSelected: boolean;
}

@Component
export default class extends BaseCalendarVue {

  @Prop({ required: false, default: () => [] })
  private selectableDates: SelectableDate[];

  public dateFormat(date: Date): string {
    return(
      `<span style="display: inline-block;">${date.getFullYear()}年</span>` +
      `<span style="display: inline-block;">${date.getMonth() + 1}月</span>`
    );
  }
  protected minDate(): Date | null {
    if (!this.viewDate) { return null; }
    const minDate = new Date(this.viewDate);
    minDate.setDate(1);
    return minDate;
  }

  protected maxDate(): Date | null {
    if (!this.viewDate) { return null; }
    const lastDate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 0).getDate();
    return new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), lastDate);
  }

  private getDateClassName(date: Date) {
    const nowDate = new Date();
    nowDate.setHours(0);
    nowDate.setMinutes(0);
    nowDate.setSeconds(0);
    // const holiday = date.getDay() === 0 ? " holiday" : "";
    const holiday = false ? ' holiday' : '';
    const today = (
      date.getFullYear() === nowDate.getFullYear() &&
      date.getMonth() === nowDate.getMonth() &&
      date.getDate() === nowDate.getDate()
      ) ? ' today' : '';
    return date.getMonth() === this.viewDate.getMonth() ?
      `current-month${holiday}${today}` :
      `different-month${holiday}${today}`;
  }

  private hasEvent(nowDate: Date) {
    return this.events.find((calendarEvent: CalendarEvent) => {
      return this.enableEvent(calendarEvent, nowDate);
    }) !== undefined;
  }

  private clickCell(date: Date) {
    if (!this.hasEvent(date)) { return; }
    this.$emit('click-cell', date);
  }

  private isSelectable(date: Date) {
    const findDate = this.selectableDates.find((selectableDate: SelectableDate) => {
      return selectableDate.date.getTime() === date.getTime();
    });
    return findDate !== undefined;
  }

  private isSelected(date: Date) {
    const findDate = this.selectableDates.find((selectableDate: SelectableDate) => {
      return selectableDate.date.getTime() === date.getTime();
    });
    return !!findDate?.isSelected;
  }

  private getSelectableText(date: Date) {
    const findDate = this.selectableDates.find((selectableDate: SelectableDate) => {
      return selectableDate.date.getTime() === date.getTime();
    });
    return findDate !== undefined
      ? findDate.isSelected
        ? '選択中'
        : findDate.isSelectable
          ? '〇'
          : '×'
      : '';
  }

  private clickSelectableCell(date: Date) {
    const findDate = this.selectableDates.find((selectableDate: SelectableDate) => {
      return selectableDate.date.getTime() === date.getTime();
    });

    if (findDate) {
      findDate.isSelected = !findDate.isSelected;
      this.$forceUpdate();
    }

    this.$emit('click-selectable-date', date);
  }
}
